import Colors from 'shared/styles/colors';

type Props = {
  size?: number;
  primaryColor?: string;
  secondaryColor?: string;
};

const Loader = ({ size, primaryColor, secondaryColor }: Props) => {
  const loaderSize = size ?? 24;
  const loaderColors = {
    primary: primaryColor ?? Colors.primaryGreen,
    secondary: secondaryColor ?? Colors.lightCream,
  };

  return (
    <div
      style={{
        width: loaderSize,
        height: loaderSize,
        border: `3px solid ${loaderColors.secondary}`,
        borderTop: `3px solid ${loaderColors.primary}`,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }}
    />
  );
};

export default Loader;
